<script setup>
import { useRouter } from 'vue-router'
import { useConfigStore, useUserStore } from '~/store/index'

await useUserStore().fetchUser()
await useConfigStore().fetchConfig()

if (useConfigStore().maintenance) {
    const router = useRouter()
    router.replace('/')
}
</script>

<template>
    <div lang="html">
        <NuxtLayout>
            <NuxtPage />
        </NuxtLayout>
    </div>
</template>
